import { render } from "./CrudTransportador.vue?vue&type=template&id=14d44716"
import script from "./CrudTransportador.vue?vue&type=script&lang=ts"
export * from "./CrudTransportador.vue?vue&type=script&lang=ts"
script.render = render

export default script